<template>
  <div>
    <div class="add-box common-shadow">
      <vxe-table
          border="none"
          show-overflow
          :auto-resize="true"
          align="center"
          :data="tableData"
      >
        <vxe-table-column field="ordersNumAttached" title="订单编号" width="15%">
          <template slot-scope="{ row }">
            <a @click="openDetail(row.id)">{{ row.ordersNumAttached }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="ordersTypeText" title="订单类型" width="5%" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.ordersTypeText }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="ordersTitleAttached" title="订单标题" width="10%"></vxe-table-column>
        <vxe-table-column field="sellerName" title="销售方" width="11%"></vxe-table-column>
        <vxe-table-column field="payAmount" title="应付金额" width="8%" align="center" show-overflow>
          <template slot-scope="{ row }">
            <span>{{ row.payAmount | formatMoney }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="payedAmount" title="已付金额" width="8%" align="center" show-overflow>
          <template slot-scope="{ row }">
            <span>{{ row.payedAmount | formatMoney }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="blanaceAmount" title="未付金额" width="8%" align="center" show-overflow>
          <template slot-scope="{ row }">
            <span>{{ row.blanaceAmount | formatMoney }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="invoiceAmount" title="发票金额" width="10%" align="center" show-overflow>
          <template slot-scope="{ row }">
            <span>{{ row.invoiceAmount | formatMoney }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="relContractNum" title="关联合同" width="15%">
          <template slot-scope="{ row }">
            <span @click="showDetail(row)" style="color: #2d8cf0; cursor: pointer">{{
                row.relContractNum
              }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="files" title="附件" width="10%">
          <template v-slot="{ row }">
            <upload-detail :arrList="row.files"></upload-detail>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <vxe-modal v-model="contractModal" title="合同详情" width="1300" height="400" resize destroy-on-close
               position="center">
      <create ref="contractModal"></create>
    </vxe-modal>
    <vxe-modal v-model="detailModal" title="合同详情" width="1000" height="900" position="center" resize destroy-on-close>
      <contract-detail ref="detailModal"></contract-detail>
    </vxe-modal>
  </div>
</template>

<script>
import UploadDetail from "@/components/common/UploadDetail";
import $api from "@/apiProvider";
import create from "@/components/order2.0/Agreement/CreateModal"
import ContractDetail from "@/views/contracts/contractDetail";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  mixins: [getAuthOrization],
  components: {
    UploadDetail,
    ContractDetail,
    create
  },
  props: {
    detailData: Object,
  },
  watch: {
    detailData(val) {
      if (val) {
        this.tableData = val.attachedOrderList;
        this.orderType.map(i => {
          this.tableData.map(j => {
            if (j.ordersType === i.value) {
              j.ordersTypeText = i.label;
            }
          })
        })
      }
    },
  },
  data() {
    return {
      contractModal:false,
      detailModal:false,
      tableData: [],
      orderType: []
    }
  },
  created() {
    this.getDict(59000, 'orderType');
  },
  methods: {
    showDetail(row) {
      if (row.relContractCate === 2) {
        this.contractModal = true;
        this.$nextTick(() => {
          this.$refs.contractModal.queryContractDetail(row.relContractId);
          this.$refs.contractModal.showDetail();
        })
      } else {
        this.detailModal = true;
        this.$nextTick(()=>{
          this.$refs.detailModal.orderOpen(row.relContractId, row.relContractType);
        })
      }
    },
    closeDetail() {
      this.detailModal = false;
    },
    async getDict(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code,
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map((i) => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          });
        });
        this[key] = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    openDetail(id) {
      let obj = {};
      obj.name = `附属订单详情${id}`
      obj.path = `/subOrder/orderdetail/${id}`
      window.open(obj.path);
    },
  }
}
</script>
<style>

</style>
